/* RD-AEO-SOURCE-CONTINUITY-v1. No DOM changes or network sends. */
(function (w, d) {
  'use strict';
  if (w.rdAeoSource) return;
  var key = 'rd_aeo_source_v1', ttl = 30 * 60 * 1000, memory = null;
  var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'referrer_host'];
  function empty() { var x = {}; fields.forEach(function(k){ x[k] = ''; }); return x; }
  function allowed() {
    try { var p = w.Shopify.customerPrivacy; return p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true; }
    catch(e) { return null; }
  }
  function clear() { memory = null; try { w.sessionStorage.removeItem(key); } catch(e) {} }
  function current() {
    var x = empty(), u = new URL(w.location.href), r = null;
    fields.slice(0,5).forEach(function(k){x[k] = (u.searchParams.get(k) || '').slice(0,250);});
    try { r = new URL(d.referrer); } catch(e) {}
    var external = r && r.hostname.replace(/^www\./,'') !== u.hostname.replace(/^www\./,'');
    if (external) x.referrer_host = r.hostname.toLowerCase();
    if (!x.utm_source && external) { x.utm_source = x.referrer_host; x.utm_medium = 'referral'; }
    return x;
  }
  function get() {
    var permission = allowed();
    if (permission !== true) { if (permission === false) clear(); return empty(); }
    var now = Date.now(), x = current();
    if (x.utm_source) {
      // Capture once per document; later external/tagged landings replace earlier origins.
      if (!memory) memory = {at: now, value: x};
    } else if (!memory) {
      try { memory = JSON.parse(w.sessionStorage.getItem(key)); } catch(e) {}
    }
    if (!memory || typeof memory.at !== 'number' || now < memory.at || now - memory.at > ttl || !memory.value || !memory.value.utm_source) { clear(); return empty(); }
    var result = empty();
    fields.forEach(function(k){result[k] = typeof memory.value[k] === 'string' ? memory.value[k].slice(0,250) : '';});
    try { w.sessionStorage.setItem(key, JSON.stringify({at:memory.at,value:result})); } catch(e) {}
    return result;
  }
  w.rdAeoSource = {get:get};
  d.addEventListener('visitorConsentCollected', function(){ if (allowed() === false) clear(); get(); });
  if (allowed()) get();
  else {
    if (allowed() === false) clear();
    try { w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if (!error) get();}); } catch(e) {}
  }
})(window, document);
